(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $6ec7bc9bec7fad01$exports = {};
var $e0990929c82081d0$exports = {};
!function(t, e) {
    $e0990929c82081d0$exports = e();
}($e0990929c82081d0$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $e799568ca1e7e799$exports = {};
!function(t, i) {
    $e799568ca1e7e799$exports = i();
}($e799568ca1e7e799$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});


$e0990929c82081d0$exports.extend($e799568ca1e7e799$exports);
const $6ec7bc9bec7fad01$var$getDateFor = ({ day: day = 1, month: month, year: year })=>$e0990929c82081d0$exports(`${year}-${month}-${day}`, "YYYY-M-D");
const $6ec7bc9bec7fad01$var$getNthDayOf = (n, day, month, year)=>{
    let result = $e0990929c82081d0$exports($6ec7bc9bec7fad01$var$getDateFor({
        month: month,
        year: year
    })).day(day);
    // dayjs.day(x) can return a time in the past (relative to the date being
    // operated on), because it returns a time from within the operand date's
    // current week. E.g.:
    //
    // date = July 1, 2021 # Thursday
    // dayjs(date).day(0)  # Get Sunday
    // # returns June 27, 2021
    if (result.month() !== month - 1) result = result.add(1, "week");
    result = result.add(n - 1, "week");
    return result;
};
const $6ec7bc9bec7fad01$var$getLastDayOf = (day, month, year)=>{
    const daysInMonth = $e0990929c82081d0$exports($6ec7bc9bec7fad01$var$getDateFor({
        month: month,
        year: year
    })).daysInMonth();
    const lastDayOfMonth = $e0990929c82081d0$exports(`${year}-${month}-${daysInMonth}`, "YYYY-M-D");
    let result = lastDayOfMonth.day(day);
    // See above comment for more details. TL;DR is dayjs.day(x) is not
    // constrained to the same month as the operand object.
    if (result.month() !== month - 1) result = result.subtract(1, "week");
    return result;
};
const $6ec7bc9bec7fad01$var$allFederalHolidaysForYear = (year = new Date().getFullYear(), { shiftSaturdayHolidays: shiftSaturdayHolidays = true, shiftSundayHolidays: shiftSundayHolidays = true } = {})=>{
    const holidays = [];
    // New Year's Day
    holidays.push({
        name: `New Year's Day`,
        date: $6ec7bc9bec7fad01$var$getDateFor({
            day: 1,
            month: 1,
            year: year
        })
    });
    // Birthday of Martin Luther King, Jr.
    // Third Monday of January; fun fact: actual birthday is January 15
    holidays.push({
        name: `Birthday of Martin Luther King, Jr.`,
        date: $6ec7bc9bec7fad01$var$getNthDayOf(3, 1, 1, year)
    });
    // Washington's Birthday
    // Third Monday of February; fun fact: actual birthday is February 22
    // Fun fact 2: officially "Washington's Birthday," not "President's Day"
    holidays.push({
        name: `Washington's Birthday`,
        alsoObservedAs: "Presidents' Day",
        date: $6ec7bc9bec7fad01$var$getNthDayOf(3, 1, 2, year)
    });
    // Memorial Day
    // Last Monday of May
    holidays.push({
        name: `Memorial Day`,
        date: $6ec7bc9bec7fad01$var$getLastDayOf(1, 5, year)
    });
    if (year > 2020) // Juneteenth
    holidays.push({
        name: `Juneteenth National Independence Day`,
        date: $6ec7bc9bec7fad01$var$getDateFor({
            day: 19,
            month: 6,
            year: year
        })
    });
    // Independence Day
    holidays.push({
        name: `Independence Day`,
        date: $6ec7bc9bec7fad01$var$getDateFor({
            day: 4,
            month: 7,
            year: year
        })
    });
    // Labor Day
    // First Monday in September
    holidays.push({
        name: `Labor Day`,
        date: $6ec7bc9bec7fad01$var$getNthDayOf(1, 1, 9, year)
    });
    // Columbus Day
    // Second Monday in October
    holidays.push({
        name: `Columbus Day`,
        alsoObservedAs: "Indigenous Peoples' Day",
        date: $6ec7bc9bec7fad01$var$getNthDayOf(2, 1, 10, year)
    });
    // Veterans Day
    holidays.push({
        name: `Veterans Day`,
        date: $6ec7bc9bec7fad01$var$getDateFor({
            day: 11,
            month: 11,
            year: year
        })
    });
    // Thanksgiving Day
    // Fourth Thursday of November
    holidays.push({
        name: `Thanksgiving Day`,
        date: $6ec7bc9bec7fad01$var$getNthDayOf(4, 4, 11, year)
    });
    // Christmas Day
    holidays.push({
        name: `Christmas Day`,
        date: $6ec7bc9bec7fad01$var$getDateFor({
            day: 25,
            month: 12,
            year: year
        })
    });
    return holidays.map((holiday)=>{
        let date = $e0990929c82081d0$exports(holiday.date);
        if (date.day() === 0 && shiftSundayHolidays) // Actual holiday falls on Sunday. Shift the observed date forward to
        // Monday.
        date = date.add(1, "day");
        if (date.day() === 6 && shiftSaturdayHolidays) // Actual holiday falls on Saturday. Shift the observed date backward
        // to Friday.
        date = date.subtract(1, "day");
        return {
            name: holiday.name,
            alsoObservedAs: holiday.alsoObservedAs,
            date: date.toDate(),
            dateString: date.format("YYYY-MM-DD")
        };
    });
};
const $6ec7bc9bec7fad01$var$isAHoliday = (date = new Date(), { shiftSaturdayHolidays: shiftSaturdayHolidays = true, shiftSundayHolidays: shiftSundayHolidays = true, utc: utc = false } = {})=>{
    const newDate = utc ? $e0990929c82081d0$exports.utc(date) : $e0990929c82081d0$exports(date);
    const year = newDate.year();
    const shift = {
        shiftSaturdayHolidays: shiftSaturdayHolidays,
        shiftSundayHolidays: shiftSundayHolidays
    };
    // Get the holidays this year, plus check if New Year's Day of next year is
    // observed on December 31 and if so, add it to this year's list.
    const allForYear = $6ec7bc9bec7fad01$var$allFederalHolidaysForYear(year, shift);
    const nextYear = $6ec7bc9bec7fad01$var$allFederalHolidaysForYear(year + 1, shift);
    allForYear.push(nextYear[0]);
    // If any dates in this year's holiday list match the one passed in, then
    // the passed-in date is a holiday.  Otherwise, it is not.
    return allForYear.some((holiday)=>holiday.dateString === newDate.format("YYYY-MM-DD"));
};
const $6ec7bc9bec7fad01$var$getOneYearFromNow = ()=>{
    const future = new Date();
    future.setUTCFullYear(future.getUTCFullYear() + 1);
    return future;
};
const $6ec7bc9bec7fad01$var$federalHolidaysInRange = (startDate = new Date(), endDate = $6ec7bc9bec7fad01$var$getOneYearFromNow(), options)=>{
    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();
    const candidates = [];
    for(let year = startYear; year <= endYear; year += 1)candidates.push(...$6ec7bc9bec7fad01$var$allFederalHolidaysForYear(year, options));
    return candidates.filter((h)=>h.date >= startDate && h.date <= endDate);
};
$6ec7bc9bec7fad01$exports = {
    isAHoliday: $6ec7bc9bec7fad01$var$isAHoliday,
    allForYear: $6ec7bc9bec7fad01$var$allFederalHolidaysForYear,
    inRange: $6ec7bc9bec7fad01$var$federalHolidaysInRange
};


const $b25b0b5411c28ac7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $b25b0b5411c28ac7$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $b25b0b5411c28ac7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $937fcf7e723dd6d7$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $2febde47bb98bab0$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $2febde47bb98bab0$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $2febde47bb98bab0$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2febde47bb98bab0$export$cbf60ecb96cbb82f = {
    date: (0, $937fcf7e723dd6d7$export$38e44e97ce4dbb7d)({
        formats: $2febde47bb98bab0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $937fcf7e723dd6d7$export$38e44e97ce4dbb7d)({
        formats: $2febde47bb98bab0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $937fcf7e723dd6d7$export$38e44e97ce4dbb7d)({
        formats: $2febde47bb98bab0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $8bc51fb51fb6cd5f$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $8bc51fb51fb6cd5f$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$8bc51fb51fb6cd5f$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $d1b31fbcf71c7062$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $bcec6c2f03a4d00e$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $bcec6c2f03a4d00e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $bcec6c2f03a4d00e$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $bcec6c2f03a4d00e$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $bcec6c2f03a4d00e$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $bcec6c2f03a4d00e$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $bcec6c2f03a4d00e$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $bcec6c2f03a4d00e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bcec6c2f03a4d00e$var$ordinalNumber,
    era: (0, $d1b31fbcf71c7062$export$63596d6ee8878b25)({
        values: $bcec6c2f03a4d00e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $d1b31fbcf71c7062$export$63596d6ee8878b25)({
        values: $bcec6c2f03a4d00e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $d1b31fbcf71c7062$export$63596d6ee8878b25)({
        values: $bcec6c2f03a4d00e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $d1b31fbcf71c7062$export$63596d6ee8878b25)({
        values: $bcec6c2f03a4d00e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $d1b31fbcf71c7062$export$63596d6ee8878b25)({
        values: $bcec6c2f03a4d00e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bcec6c2f03a4d00e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $397a5297d63bb64f$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $397a5297d63bb64f$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $397a5297d63bb64f$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $397a5297d63bb64f$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $397a5297d63bb64f$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $ea3e1a3193098a99$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $7fb87efbf3834a7c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $7fb87efbf3834a7c$var$parseOrdinalNumberPattern = /\d+/i;
const $7fb87efbf3834a7c$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $7fb87efbf3834a7c$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $7fb87efbf3834a7c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $7fb87efbf3834a7c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $7fb87efbf3834a7c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $7fb87efbf3834a7c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $7fb87efbf3834a7c$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $7fb87efbf3834a7c$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $7fb87efbf3834a7c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $7fb87efbf3834a7c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $7fb87efbf3834a7c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $ea3e1a3193098a99$export$fdaf2fd6d7edde95)({
        matchPattern: $7fb87efbf3834a7c$var$matchOrdinalNumberPattern,
        parsePattern: $7fb87efbf3834a7c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $397a5297d63bb64f$export$1430a0f35710914d)({
        matchPatterns: $7fb87efbf3834a7c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $397a5297d63bb64f$export$1430a0f35710914d)({
        matchPatterns: $7fb87efbf3834a7c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $397a5297d63bb64f$export$1430a0f35710914d)({
        matchPatterns: $7fb87efbf3834a7c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $397a5297d63bb64f$export$1430a0f35710914d)({
        matchPatterns: $7fb87efbf3834a7c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $397a5297d63bb64f$export$1430a0f35710914d)({
        matchPatterns: $7fb87efbf3834a7c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7fb87efbf3834a7c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $df2dd90e7c50f6a9$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $b25b0b5411c28ac7$export$2c14ff85d6318973),
    formatLong: (0, $2febde47bb98bab0$export$cbf60ecb96cbb82f),
    formatRelative: (0, $8bc51fb51fb6cd5f$export$8fbbfd65594f46a0),
    localize: (0, $bcec6c2f03a4d00e$export$b3bd0bc58e36cd63),
    match: (0, $7fb87efbf3834a7c$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$df2dd90e7c50f6a9$export$2e2bcd8739ae039 = $df2dd90e7c50f6a9$export$137380d9ce54f7f;


let $7d20c1ccd7dd6a35$var$defaultOptions = {};
function $7d20c1ccd7dd6a35$export$430a3269e24b912e() {
    return $7d20c1ccd7dd6a35$var$defaultOptions;
}
function $7d20c1ccd7dd6a35$export$95365be1b0704abc(newOptions) {
    $7d20c1ccd7dd6a35$var$defaultOptions = newOptions;
}


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $6e9d8fa85a388a89$export$dfd9b671c89acc8e = 7;
const $6e9d8fa85a388a89$export$3913210603d8e9ae = 365.2425;
const $6e9d8fa85a388a89$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $6e9d8fa85a388a89$export$4dec998e48f9c246 = -$6e9d8fa85a388a89$export$81caae6e1cc7a622;
const $6e9d8fa85a388a89$export$4fad13613e88edc8 = 604800000;
const $6e9d8fa85a388a89$export$b76b1809a2898f9a = 86400000;
const $6e9d8fa85a388a89$export$91246f0b9bd9beff = 60000;
const $6e9d8fa85a388a89$export$7f72910d6dfd237a = 3600000;
const $6e9d8fa85a388a89$export$397c2d5776aa9055 = 1000;
const $6e9d8fa85a388a89$export$3633035e63cee86a = 525600;
const $6e9d8fa85a388a89$export$ab7da2ccd1075c38 = 43200;
const $6e9d8fa85a388a89$export$2423174df8cd3cd2 = 1440;
const $6e9d8fa85a388a89$export$f2f5ae5a8e2d8f9f = 60;
const $6e9d8fa85a388a89$export$3c58128db900d44e = 3;
const $6e9d8fa85a388a89$export$80d7e435f744f319 = 12;
const $6e9d8fa85a388a89$export$4db7641526e3241f = 4;
const $6e9d8fa85a388a89$export$698aec755e92c695 = 3600;
const $6e9d8fa85a388a89$export$a77c1a7ebebe2a5a = 60;
const $6e9d8fa85a388a89$export$815a9362476d2fe3 = $6e9d8fa85a388a89$export$698aec755e92c695 * 24;
const $6e9d8fa85a388a89$export$34804a017b31e2fe = $6e9d8fa85a388a89$export$815a9362476d2fe3 * 7;
const $6e9d8fa85a388a89$export$7271e9e3478110d1 = $6e9d8fa85a388a89$export$815a9362476d2fe3 * $6e9d8fa85a388a89$export$3913210603d8e9ae;
const $6e9d8fa85a388a89$export$8e6600bbdee7dabb = $6e9d8fa85a388a89$export$7271e9e3478110d1 / 12;
const $6e9d8fa85a388a89$export$be1dccf2de902d31 = $6e9d8fa85a388a89$export$8e6600bbdee7dabb * 3;
const $6e9d8fa85a388a89$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $94e2600e6614cc67$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $6e9d8fa85a388a89$export$2a7b97929c48d47d) in date) return date[0, $6e9d8fa85a388a89$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$94e2600e6614cc67$export$2e2bcd8739ae039 = $94e2600e6614cc67$export$ead8a1812b171991;


function $5806bcec89744c32$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $94e2600e6614cc67$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$5806bcec89744c32$export$2e2bcd8739ae039 = $5806bcec89744c32$export$e67a095c620b86fe;


function $bf76c6c68c67552d$export$113002b5eff6e430(date) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $8ed334072e1c80b3$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $94e2600e6614cc67$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$eb904f8e2d8bb2b8$export$2e2bcd8739ae039 = $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2;


function $b60d0a59df25f16c$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $8ed334072e1c80b3$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $bf76c6c68c67552d$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $bf76c6c68c67552d$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $6e9d8fa85a388a89$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$b60d0a59df25f16c$export$2e2bcd8739ae039 = $b60d0a59df25f16c$export$4a02e9c37dab4871;



function $70a914b2bfa6cf87$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$70a914b2bfa6cf87$export$2e2bcd8739ae039 = $70a914b2bfa6cf87$export$f91e89d3d0406102;



function $db8aceab23c59713$export$d3b42cd8452deec(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $b60d0a59df25f16c$export$4a02e9c37dab4871)(_date, (0, $70a914b2bfa6cf87$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$db8aceab23c59713$export$2e2bcd8739ae039 = $db8aceab23c59713$export$d3b42cd8452deec;





function $19bc147add1de659$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$19bc147add1de659$export$2e2bcd8739ae039 = $19bc147add1de659$export$42c81a444fbfb5d4;


function $f922ea67b098f800$export$6173213f95a4431e(date, options) {
    return (0, $19bc147add1de659$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$f922ea67b098f800$export$2e2bcd8739ae039 = $f922ea67b098f800$export$6173213f95a4431e;






function $a36a67fbf4e7f789$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $94e2600e6614cc67$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $f922ea67b098f800$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $94e2600e6614cc67$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $f922ea67b098f800$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$a36a67fbf4e7f789$export$2e2bcd8739ae039 = $a36a67fbf4e7f789$export$3dbc52535f6f8fcc;



function $1390bfa921613bda$export$236bdfa374eb69a9(date, options) {
    const year = (0, $a36a67fbf4e7f789$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $94e2600e6614cc67$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $f922ea67b098f800$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$1390bfa921613bda$export$2e2bcd8739ae039 = $1390bfa921613bda$export$236bdfa374eb69a9;



function $c7378692dfd4ab30$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $f922ea67b098f800$export$6173213f95a4431e)(_date) - +(0, $1390bfa921613bda$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $6e9d8fa85a388a89$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$c7378692dfd4ab30$export$2e2bcd8739ae039 = $c7378692dfd4ab30$export$7cabdc5698b63e2f;











function $9f2d4df197546c06$export$12d572480ceb6e58(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $94e2600e6614cc67$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $19bc147add1de659$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $94e2600e6614cc67$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $19bc147add1de659$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$9f2d4df197546c06$export$2e2bcd8739ae039 = $9f2d4df197546c06$export$12d572480ceb6e58;



function $6d7445628bc657f6$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $9f2d4df197546c06$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $94e2600e6614cc67$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $19bc147add1de659$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$6d7445628bc657f6$export$2e2bcd8739ae039 = $6d7445628bc657f6$export$bb7b45bb8e74da0f;



function $3c6a47f4b80291d0$export$efe19b760242b2fc(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $19bc147add1de659$export$42c81a444fbfb5d4)(_date, options) - +(0, $6d7445628bc657f6$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $6e9d8fa85a388a89$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$3c6a47f4b80291d0$export$2e2bcd8739ae039 = $3c6a47f4b80291d0$export$efe19b760242b2fc;



function $6c7b80446273fbf1$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $f530ec37dbf8665a$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $a61424cc6e7370c5$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $a61424cc6e7370c5$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $9f2d4df197546c06$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $a36a67fbf4e7f789$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $3c6a47f4b80291d0$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $c7378692dfd4ab30$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $db8aceab23c59713$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $a61424cc6e7370c5$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $a61424cc6e7370c5$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $a61424cc6e7370c5$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(minutes, 2);
}
function $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $a61424cc6e7370c5$var$formatTimezone(offset, delimiter);
}
function $a61424cc6e7370c5$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $a111a280e7a3f1fa$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $a111a280e7a3f1fa$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $a111a280e7a3f1fa$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $a111a280e7a3f1fa$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $a111a280e7a3f1fa$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $a111a280e7a3f1fa$var$timeLongFormatter(timePattern, formatLong));
};
const $a111a280e7a3f1fa$export$70cc8fd02856fd58 = {
    p: $a111a280e7a3f1fa$var$timeLongFormatter,
    P: $a111a280e7a3f1fa$var$dateTimeLongFormatter
};


const $8b24592752d42d9c$var$dayOfYearTokenRE = /^D+$/;
const $8b24592752d42d9c$var$weekYearTokenRE = /^Y+$/;
const $8b24592752d42d9c$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $8b24592752d42d9c$export$c6cc36aa33304772(token) {
    return $8b24592752d42d9c$var$dayOfYearTokenRE.test(token);
}
function $8b24592752d42d9c$export$c6b49d6dceb604a1(token) {
    return $8b24592752d42d9c$var$weekYearTokenRE.test(token);
}
function $8b24592752d42d9c$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $8b24592752d42d9c$var$message(token, format, input);
    console.warn(_message);
    if ($8b24592752d42d9c$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $8b24592752d42d9c$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $3a7c1ce5b86d595e$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$3a7c1ce5b86d595e$export$2e2bcd8739ae039 = $3a7c1ce5b86d595e$export$871608497c498473;



function $3feef11dde2315db$export$1ea939691cdc45b8(date) {
    return !(!(0, $3a7c1ce5b86d595e$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $5806bcec89744c32$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$3feef11dde2315db$export$2e2bcd8739ae039 = $3feef11dde2315db$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $d1f6d53b6dcbe5f6$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $d1f6d53b6dcbe5f6$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $d1f6d53b6dcbe5f6$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $d1f6d53b6dcbe5f6$var$doubleQuoteRegExp = /''/g;
const $d1f6d53b6dcbe5f6$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $d1f6d53b6dcbe5f6$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $df2dd90e7c50f6a9$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $3feef11dde2315db$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($d1f6d53b6dcbe5f6$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $a111a280e7a3f1fa$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($d1f6d53b6dcbe5f6$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $d1f6d53b6dcbe5f6$var$cleanEscapedString(substring)
        };
        if ((0, $a61424cc6e7370c5$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($d1f6d53b6dcbe5f6$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $8b24592752d42d9c$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $8b24592752d42d9c$export$c6cc36aa33304772)(token)) (0, $8b24592752d42d9c$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $a61424cc6e7370c5$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $d1f6d53b6dcbe5f6$var$cleanEscapedString(input) {
    const matched = input.match($d1f6d53b6dcbe5f6$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($d1f6d53b6dcbe5f6$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$d1f6d53b6dcbe5f6$export$2e2bcd8739ae039 = $d1f6d53b6dcbe5f6$export$d9468344d3651243;



function $d1a080689c5f0d40$export$430a3269e24b912e() {
    return Object.assign({}, (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$d1a080689c5f0d40$export$2e2bcd8739ae039 = $d1a080689c5f0d40$export$430a3269e24b912e;


function $42b17b11307caa95$export$90e6cdae187a86ac(length, date, options) {
    const defaultOptions = (0, $d1a080689c5f0d40$export$430a3269e24b912e)();
    const dtf = $42b17b11307caa95$var$getDTF(length, options.timeZone, options.locale ?? defaultOptions.locale);
    return 'formatToParts' in dtf ? $42b17b11307caa95$var$partsTimeZone(dtf, date) : $42b17b11307caa95$var$hackyTimeZone(dtf, date);
}
function $42b17b11307caa95$var$partsTimeZone(dtf, date) {
    const formatted = dtf.formatToParts(date);
    for(let i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
    return undefined;
}
function $42b17b11307caa95$var$hackyTimeZone(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, '');
    const tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $42b17b11307caa95$var$getDTF(length, timeZone, locale) {
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}


/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $2b7865430f321497$export$6f7bba78170cdfff(date, timeZone) {
    const dtf = $2b7865430f321497$var$getDateTimeFormat(timeZone);
    return 'formatToParts' in dtf ? $2b7865430f321497$var$partsOffset(dtf, date) : $2b7865430f321497$var$hackyOffset(dtf, date);
}
const $2b7865430f321497$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $2b7865430f321497$var$partsOffset(dtf, date) {
    try {
        const formatted = dtf.formatToParts(date);
        const filled = [];
        for(let i = 0; i < formatted.length; i++){
            const pos = $2b7865430f321497$var$typeToPos[formatted[i].type];
            if (pos !== undefined) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $2b7865430f321497$var$hackyOffset(dtf, date) {
    const formatted = dtf.format(date);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // const [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parseInt(parsed[3], 10),
        parseInt(parsed[1], 10),
        parseInt(parsed[2], 10),
        parseInt(parsed[4], 10),
        parseInt(parsed[5], 10),
        parseInt(parsed[6], 10)
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
const $2b7865430f321497$var$dtfCache = {};
// New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
const $2b7865430f321497$var$testDateFormatted = new Intl.DateTimeFormat('en-US', {
    hourCycle: 'h23',
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
}).format(new Date('2014-06-25T04:00:00.123Z'));
const $2b7865430f321497$var$hourCycleSupported = $2b7865430f321497$var$testDateFormatted === '06/25/2014, 00:00:00' || $2b7865430f321497$var$testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
function $2b7865430f321497$var$getDateTimeFormat(timeZone) {
    if (!$2b7865430f321497$var$dtfCache[timeZone]) $2b7865430f321497$var$dtfCache[timeZone] = $2b7865430f321497$var$hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
        hourCycle: 'h23',
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }) : new Intl.DateTimeFormat('en-US', {
        hour12: false,
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
    return $2b7865430f321497$var$dtfCache[timeZone];
}


/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $96c90c1aba4060a2$export$461165d00818234e(fullYear, month, day, hour, minute, second, millisecond) {
    const utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}


const $0e90e1307f8b40e4$var$MILLISECONDS_IN_HOUR = 3600000;
const $0e90e1307f8b40e4$var$MILLISECONDS_IN_MINUTE = 60000;
const $0e90e1307f8b40e4$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $0e90e1307f8b40e4$export$57649162eea44a93(timezoneString, date, isUtcDate) {
    // Empty string
    if (!timezoneString) return 0;
    // Z
    let token = $0e90e1307f8b40e4$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    let hours;
    let absoluteOffset;
    // ±hh
    token = $0e90e1307f8b40e4$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$0e90e1307f8b40e4$var$validateTimezone(hours)) return NaN;
        return -(hours * $0e90e1307f8b40e4$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $0e90e1307f8b40e4$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        const minutes = parseInt(token[3], 10);
        if (!$0e90e1307f8b40e4$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $0e90e1307f8b40e4$var$MILLISECONDS_IN_HOUR + minutes * $0e90e1307f8b40e4$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($0e90e1307f8b40e4$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        const utcDate = isUtcDate ? date : $0e90e1307f8b40e4$var$toUtcDate(date);
        const offset = $0e90e1307f8b40e4$var$calcOffset(utcDate, timezoneString);
        const fixedOffset = isUtcDate ? offset : $0e90e1307f8b40e4$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $0e90e1307f8b40e4$var$toUtcDate(date) {
    return (0, $96c90c1aba4060a2$export$461165d00818234e)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $0e90e1307f8b40e4$var$calcOffset(date, timezoneString) {
    const tokens = (0, $2b7865430f321497$export$6f7bba78170cdfff)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    const asUTC = (0, $96c90c1aba4060a2$export$461165d00818234e)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    let asTS = date.getTime();
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $0e90e1307f8b40e4$var$fixOffset(date, offset, timezoneString) {
    const localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    let utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    const o2 = $0e90e1307f8b40e4$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    const o3 = $0e90e1307f8b40e4$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $0e90e1307f8b40e4$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
const $0e90e1307f8b40e4$var$validIANATimezoneCache = {};
function $0e90e1307f8b40e4$var$isValidTimezoneIANAString(timeZoneString) {
    if ($0e90e1307f8b40e4$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $0e90e1307f8b40e4$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}


const $75397b95bd056ec8$var$MILLISECONDS_IN_MINUTE = 60000;
const $75397b95bd056ec8$export$fe98a034cfb96d55 = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, options) {
        const timezoneOffset = $75397b95bd056ec8$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $75397b95bd056ec8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $75397b95bd056ec8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $75397b95bd056ec8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, options) {
        const timezoneOffset = $75397b95bd056ec8$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $75397b95bd056ec8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $75397b95bd056ec8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $75397b95bd056ec8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, options) {
        const timezoneOffset = $75397b95bd056ec8$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $75397b95bd056ec8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $75397b95bd056ec8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $42b17b11307caa95$export$90e6cdae187a86ac)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $42b17b11307caa95$export$90e6cdae187a86ac)('long', date, options);
        }
    }
};
function $75397b95bd056ec8$var$getTimeZoneOffset(timeZone, originalDate) {
    const timeZoneOffset = timeZone ? (0, $0e90e1307f8b40e4$export$57649162eea44a93)(timeZone, originalDate, true) / $75397b95bd056ec8$var$MILLISECONDS_IN_MINUTE : originalDate?.getTimezoneOffset() ?? 0;
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $75397b95bd056ec8$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? '-' : '';
    let output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $75397b95bd056ec8$var$formatTimezone(offset, delimiter = '') {
    const sign = offset > 0 ? '-' : '+';
    const absOffset = Math.abs(offset);
    const hours = $75397b95bd056ec8$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    const minutes = $75397b95bd056ec8$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimiter + minutes;
}
function $75397b95bd056ec8$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? '-' : '+';
        return sign + $75397b95bd056ec8$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $75397b95bd056ec8$var$formatTimezone(offset, delimiter);
}
function $75397b95bd056ec8$var$formatTimezoneShort(offset, delimiter = '') {
    const sign = offset > 0 ? '-' : '+';
    const absOffset = Math.abs(offset);
    const hours = Math.floor(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + $75397b95bd056ec8$var$addLeadingZeros(minutes, 2);
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $bef409ee3eb39487$export$113002b5eff6e430(date) {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return +date - +utcDate;
}



/** Regex to identify the presence of a time zone specifier in a date string */ const $f9a0cd8a687d8af8$export$a859e97a80802e41 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;


const $6b0cd02ed6451f72$var$MILLISECONDS_IN_HOUR = 3600000;
const $6b0cd02ed6451f72$var$MILLISECONDS_IN_MINUTE = 60000;
const $6b0cd02ed6451f72$var$DEFAULT_ADDITIONAL_DIGITS = 2;
const $6b0cd02ed6451f72$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $f9a0cd8a687d8af8$export$a859e97a80802e41)
};
function $6b0cd02ed6451f72$export$e67a095c620b86fe(argument, options = {}) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    const additionalDigits = options.additionalDigits == null ? $6b0cd02ed6451f72$var$DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    const dateStrings = $6b0cd02ed6451f72$var$splitDateString(argument);
    const { year: year, restDateString: restDateString } = $6b0cd02ed6451f72$var$parseYear(dateStrings.date, additionalDigits);
    const date = $6b0cd02ed6451f72$var$parseDate(restDateString, year);
    if (date === null || isNaN(date.getTime())) return new Date(NaN);
    if (date) {
        const timestamp = date.getTime();
        let time = 0;
        let offset;
        if (dateStrings.time) {
            time = $6b0cd02ed6451f72$var$parseTime(dateStrings.time);
            if (time === null || isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $0e90e1307f8b40e4$export$57649162eea44a93)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, $bef409ee3eb39487$export$113002b5eff6e430)(new Date(timestamp + time));
            offset = (0, $bef409ee3eb39487$export$113002b5eff6e430)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $6b0cd02ed6451f72$var$splitDateString(dateString) {
    const dateStrings = {};
    let parts = $6b0cd02ed6451f72$var$patterns.dateTimePattern.exec(dateString);
    let timeString;
    if (!parts) {
        parts = $6b0cd02ed6451f72$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        const token = $6b0cd02ed6451f72$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $6b0cd02ed6451f72$var$parseYear(dateString, additionalDigits) {
    if (dateString) {
        const patternYYY = $6b0cd02ed6451f72$var$patterns.YYY[additionalDigits];
        const patternYYYYY = $6b0cd02ed6451f72$var$patterns.YYYYY[additionalDigits];
        // YYYY or ±YYYYY
        let token = $6b0cd02ed6451f72$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            const yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        // YY or ±YYY
        token = $6b0cd02ed6451f72$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            const centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $6b0cd02ed6451f72$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    let date;
    let month;
    let week;
    // YYYY
    if (!dateString || !dateString.length) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    let token = $6b0cd02ed6451f72$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$6b0cd02ed6451f72$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $6b0cd02ed6451f72$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        const dayOfYear = parseInt(token[1], 10);
        if (!$6b0cd02ed6451f72$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $6b0cd02ed6451f72$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        const day = parseInt(token[2], 10);
        if (!$6b0cd02ed6451f72$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $6b0cd02ed6451f72$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$6b0cd02ed6451f72$var$validateWeekDate(week)) return new Date(NaN);
        return $6b0cd02ed6451f72$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $6b0cd02ed6451f72$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        const dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$6b0cd02ed6451f72$var$validateWeekDate(week, dayOfWeek)) return new Date(NaN);
        return $6b0cd02ed6451f72$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $6b0cd02ed6451f72$var$parseTime(timeString) {
    let hours;
    let minutes;
    // hh
    let token = $6b0cd02ed6451f72$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$6b0cd02ed6451f72$var$validateTime(hours)) return NaN;
        return hours % 24 * $6b0cd02ed6451f72$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $6b0cd02ed6451f72$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$6b0cd02ed6451f72$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $6b0cd02ed6451f72$var$MILLISECONDS_IN_HOUR + minutes * $6b0cd02ed6451f72$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $6b0cd02ed6451f72$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        const seconds = parseFloat(token[3].replace(',', '.'));
        if (!$6b0cd02ed6451f72$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $6b0cd02ed6451f72$var$MILLISECONDS_IN_HOUR + minutes * $6b0cd02ed6451f72$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $6b0cd02ed6451f72$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
const $6b0cd02ed6451f72$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $6b0cd02ed6451f72$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $6b0cd02ed6451f72$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $6b0cd02ed6451f72$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        const isLeapYear = $6b0cd02ed6451f72$var$isLeapYearIndex(year);
        if (isLeapYear && date > $6b0cd02ed6451f72$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $6b0cd02ed6451f72$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $6b0cd02ed6451f72$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    const isLeapYear = $6b0cd02ed6451f72$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $6b0cd02ed6451f72$var$validateWeekDate(week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $6b0cd02ed6451f72$var$validateTime(hours, minutes, seconds) {
    if (hours < 0 || hours >= 25) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}


const $3aa79ebf3e2d6dab$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $3aa79ebf3e2d6dab$export$d9468344d3651243(date, formatStr, options = {}) {
    formatStr = String(formatStr);
    const matches = formatStr.match($3aa79ebf3e2d6dab$var$tzFormattingTokensRegExp);
    if (matches) {
        const d = (0, $6b0cd02ed6451f72$export$e67a095c620b86fe)(options.originalDate || date, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result; // This is a quoted portion, matched only to ensure we don't match inside it
            const pos = result.indexOf(token);
            const precededByQuotedSection = result[pos - 1] === "'";
            const replaced = result.replace(token, "'" + (0, $75397b95bd056ec8$export$fe98a034cfb96d55)[token[0]](d, token, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, $d1f6d53b6dcbe5f6$export$d9468344d3651243)(date, formatStr, options);
}





function $1ac9ce7983f26363$export$3ee79d090bac6d33(date, timeZone, options) {
    date = (0, $6b0cd02ed6451f72$export$e67a095c620b86fe)(date, options);
    const offsetMilliseconds = (0, $0e90e1307f8b40e4$export$57649162eea44a93)(timeZone, date, true);
    const d = new Date(date.getTime() - offsetMilliseconds);
    const resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}


function $20d6ded5c93e1459$export$b3ea52468069e196(date, timeZone, formatStr, options) {
    options = {
        ...options,
        timeZone: timeZone,
        originalDate: date
    };
    return (0, $3aa79ebf3e2d6dab$export$d9468344d3651243)((0, $1ac9ce7983f26363$export$3ee79d090bac6d33)(date, timeZone, {
        timeZone: options.timeZone
    }), formatStr, options);
}






function $952ed55040a5dee1$export$7e1e8af4bb294f2b(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, $f9a0cd8a687d8af8$export$a859e97a80802e41))) return (0, $6b0cd02ed6451f72$export$e67a095c620b86fe)(date, {
        ...options,
        timeZone: timeZone
    });
    date = (0, $6b0cd02ed6451f72$export$e67a095c620b86fe)(date, options);
    const utc = (0, $96c90c1aba4060a2$export$461165d00818234e)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()).getTime();
    const offsetMilliseconds = (0, $0e90e1307f8b40e4$export$57649162eea44a93)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}




function $749a358805504027$export$4c9db454e2785fd9(timeZone, date) {
    return -(0, $0e90e1307f8b40e4$export$57649162eea44a93)(timeZone, date);
}





document.addEventListener('DOMContentLoaded', function() {
    // Function to handle accordion behavior
    function handleAccordionChange(event) {
        const radio = event.target;
        if (radio.checked) {
            const headerTextElement = radio.closest('.accordion-item').querySelector('.accordion-button .js-chosen');
            const headerText = radio.getAttribute('data-name');
            headerTextElement.innerText = headerText;
            // Update the src of the image with id "bpic"
            if (radio.name === 'pic') {
                document.getElementById('bpic').src = radio.dataset.imagesourceStandard;
                document.getElementById('selected-background-sample').innerText = headerText;
            }
            if (radio.name === 'products[0]') document.getElementById('framepic').src = radio.dataset.overlay;
            // Update the total price
            updateTotalPrice();
        }
        if (!document.querySelector('input[name="products[0]"]:checked')) {
            const sizeSelected = document.querySelector('input[name="size"]:checked');
            let size = '';
            if (sizeSelected && sizeSelected.value !== '16x20' && sizeSelected.value !== '16x20pyo' && sizeSelected.value !== '16x20pdp' && sizeSelected.value !== '16x20pd') size = sizeSelected.value.replace('pyo', '').replace('pdp', '').replace('pd', '');
            document.getElementById('framepic').src = '/images/3pframes/overlays/blank' + size + '.webp';
        }
    }
    // Function to update the total price
    function updateTotalPrice() {
        let totalPrice = 0;
        const templateElem = document.getElementById('orderOptionTemplate');
        const orderOptionsList = document.getElementById('orderOptionsList');
        orderOptionsList.innerHTML = '';
        // Calculate the additional options price
        document.querySelectorAll('input[name^="products"]:checked,input[name="companylogo"]:checked,input[name="style"]:checked,input[name="size"]:checked').forEach((checkbox)=>{
            const price = parseFloat(checkbox.dataset.price);
            if (Number.isNaN(price)) return;
            totalPrice += price || 0;
            const template = templateElem.cloneNode(true);
            template.querySelector('h6').innerText = checkbox.getAttribute('data-name');
            template.querySelector('span').innerText = '$' + price.toFixed(2);
            orderOptionsList.appendChild(template);
        });
        // Update the total price display
        const totalTemplate = document.getElementById('orderTotalTemplate').cloneNode(true);
        totalTemplate.querySelector('li.list-group-item strong').innerText = `$${totalPrice.toFixed(2)}`;
        orderOptionsList.appendChild(totalTemplate);
    }
    document.querySelectorAll('input[name^="products"]').forEach((checkbox)=>{
        checkbox.addEventListener('change', updateTotalPrice);
    });
    // Add event listeners to all radio buttons with name 'delivery'
    const backgroundRadios = document.querySelectorAll('input[name="pic"]');
    backgroundRadios.forEach((radio)=>{
        radio.addEventListener('change', handleAccordionChange);
    });
    // Add event listeners to all radio buttons with name 'delivery'
    const deliveryRadios = document.querySelectorAll('input[name="delivery"]');
    deliveryRadios.forEach((radio)=>{
        radio.addEventListener('change', handleAccordionChange);
    });
    const itemVisibilityHide = function(item) {
        item.classList.add('d-none');
        item.querySelectorAll('input[required]').forEach((input)=>{
            input.setAttribute('data-required', 'required');
            input.removeAttribute('required');
            if (input.checked) input.dataset.checked = true;
            else delete input.dataset.checked;
            input.checked = false;
            const changeEvent = new Event('change');
            input.dispatchEvent(changeEvent);
        });
    };
    const itemVisibilityShow = function(item) {
        item.classList.remove('d-none');
        item.querySelectorAll('input[data-required]').forEach((input)=>{
            input.required = true;
        });
        item.querySelectorAll('input[data-checked]').forEach((input)=>{
            input.checked = true;
            const changeEvent = new Event('change');
            input.dispatchEvent(changeEvent);
        });
    };
    const portraitBaseSize = function(value) {
        return value.replace('pyo', '').replace('pdp', '').replace('pd', '');
    };
    const updateSizeOptions = ()=>{
        const selected = document.querySelector('input[name="size"]:checked');
        if (!selected) return;
        const selectedBaseSize = portraitBaseSize(selected.value);
        document.querySelectorAll('#choose-frame-item input[data-value-24x36]').forEach((input)=>{
            if (!input.dataset['value-16x20']) input.dataset['value-16x20'] = input.value;
            input.value = input.dataset['value-' + selectedBaseSize];
        });
        if ('16x20' === selectedBaseSize) {
            document.querySelectorAll('[data-content-24x36]').forEach((elem)=>{
                elem.innerText = elem.dataset['content-16x20'];
            });
            document.querySelectorAll('[data-price-24x36]').forEach((elem)=>{
                elem.dataset.price = elem.dataset['price-16x20'];
            });
        } else if ('11x14' === selectedBaseSize) {
            document.querySelectorAll('[data-content-24x36]').forEach((elem)=>{
                elem.innerText = elem.dataset['content-11x14'];
            });
            document.querySelectorAll('[data-price-24x36]').forEach((elem)=>{
                elem.dataset.price = elem.dataset['price-11x14'];
            });
        } else if ('8x10' === selectedBaseSize) {
            document.querySelectorAll('[data-content-24x36]').forEach((elem)=>{
                elem.innerText = elem.dataset['content-11x14'];
            });
            document.querySelectorAll('[data-price-24x36]').forEach((elem)=>{
                elem.dataset.price = elem.dataset['price-11x14'];
            });
        } else if ('24x36' === selectedBaseSize) {
            document.querySelectorAll('[data-content-24x36]').forEach((elem)=>{
                elem.innerText = elem.dataset['content-24x36'];
            });
            document.querySelectorAll('[data-price-24x36]').forEach((elem)=>{
                elem.dataset.price = elem.dataset['price-24x36'];
            });
        } else {
            document.querySelectorAll('[data-content-24x36]').forEach((elem)=>{
                elem.innerText = elem.dataset['content-16x20'];
            });
            document.querySelectorAll('[data-price-24x36]').forEach((elem)=>{
                elem.dataset.price = elem.dataset['price-16x20'];
            });
            document.querySelectorAll('.choose-frame-item').forEach(itemVisibilityHide);
        }
        if ('24x36' === selectedBaseSize) {
            document.querySelectorAll('#choose-background img[data-src-24x36]').forEach((img)=>{
                if (img.dataset['src-24x36']) {
                    if (!img.dataset['src-16x20']) img.dataset['src-16x20'] = img.src;
                    img.src = img.dataset['src-24x36'];
                }
            });
            document.querySelectorAll('input[data-overlay-24x36]').forEach((img)=>{
                if (img.dataset['overlay-24x36']) {
                    if (!img.dataset['overlay-16x20']) img.dataset['overlay-16x20'] = img.dataset.overlay;
                    img.dataset.overlay = img.dataset['overlay-24x36'];
                    if (img.checked) document.getElementById('framepic').src = img.dataset.overlay;
                }
            });
            document.querySelectorAll('[data-style-24x36]').forEach((elem)=>{
                if (elem.dataset['style-24x36']) {
                    if (!elem.dataset['style-16x20']) elem.dataset['style-16x20'] = elem.style.cssText;
                    elem.style = elem.dataset['style-24x36'];
                }
                if (elem.dataset['styleZoom-24x36']) {
                    if (!elem.dataset['styleZoom-16x20']) elem.dataset['styleZoom-16x20'] = elem.dataset.styleZoom;
                    elem.dataset.styleZoom = elem.dataset['styleZoom-24x36'];
                }
            });
            document.querySelectorAll('#choose-background input[data-value-24x36]').forEach((input)=>{
                if (!input.dataset['value-16x20']) input.dataset['value-16x20'] = input.value;
                input.value = input.dataset['value-24x36'];
                if (!input.dataset['imagesource-16x20']) input.dataset['imagesource-16x20'] = input.dataset.imagesourceStandard;
                if (input.dataset['imagesource-24x36']) {
                    const portraitOnly = document.querySelector('input[name="portraitonly"]:checked');
                    if (portraitOnly && 'yes' === portraitOnly.value) input.dataset.imagesourceStandard = input.dataset['imagesource-24x36'].replace('.webp', ' no text.webp');
                    else input.dataset.imagesourceStandard = input.dataset['imagesource-24x36'];
                }
                if (input.checked) document.getElementById('bpic').src = input.dataset.imagesourceStandard;
            });
            document.querySelectorAll('.show-24x36').forEach((elem)=>{
                itemVisibilityShow(elem);
            });
            document.querySelectorAll('.hide-24x36').forEach((elem)=>{
                itemVisibilityHide(elem);
            });
        } else {
            document.querySelectorAll('.hide-24x36').forEach((elem)=>{
                itemVisibilityShow(elem);
            });
            document.querySelectorAll('.show-24x36').forEach((elem)=>{
                itemVisibilityHide(elem);
            });
            document.querySelectorAll('#choose-background [data-src-24x36]').forEach((img)=>{
                if (img.dataset['src-16x20']) img.src = img.dataset['src-16x20'];
            });
            document.querySelectorAll('input[data-overlay-24x36]').forEach((img)=>{
                if (img.dataset['overlay-16x20']) {
                    img.dataset.overlay = img.dataset['overlay-16x20'];
                    if (img.checked) document.getElementById('framepic').src = img.dataset.overlay;
                }
            });
            if ('11x14' === selected.value) document.querySelectorAll('[data-style-11x14]').forEach((elem)=>{
                if (elem.dataset['style-11x14']) {
                    if (!elem.dataset['style-16x20']) elem.dataset['style-16x20'] = elem.style.cssText;
                    elem.style = elem.dataset['style-11x14'];
                }
                if (elem.dataset['styleZoom-11x14']) {
                    if (!elem.dataset['styleZoom-16x20']) elem.dataset['styleZoom-16x20'] = elem.dataset.styleZoom;
                    elem.dataset.styleZoom = elem.dataset['styleZoom-11x14'];
                }
            });
            else document.querySelectorAll('[data-style-24x36]').forEach((img)=>{
                if (img.dataset['styleZoom-16x20']) img.dataset.styleZoom = img.dataset['styleZoom-16x20'];
            });
            document.querySelectorAll('#choose-background input[data-value-24x36]').forEach((input)=>{
                if (input.dataset['value-16x20']) input.value = input.dataset['value-16x20'];
                if (input.dataset['imagesource-16x20']) input.dataset.imagesourceStandard = input.dataset['imagesource-16x20'];
                if (input.checked) document.getElementById('bpic').src = input.dataset.imagesourceStandard;
            });
        }
    };
    updateSizeOptions();
    const updatePortraitOnly = function(event) {
        if (event.target.checked && 'yes' === event.target.value) {
            document.querySelectorAll('#choose-background input[data-value-24x36]').forEach((input)=>{
                input.dataset.imagesourceStandard = input.dataset['imagesource-24x36'].replace('.webp', ' no text.webp');
                if (input.checked) document.getElementById('bpic').src = input.dataset.imagesourceStandard;
            });
            document.getElementById('customtext').closest('.input-group').classList.add('d-none');
        } else {
            document.querySelectorAll('#choose-background input[data-value-24x36]').forEach((input)=>{
                input.dataset.imagesourceStandard = input.dataset['imagesource-24x36'];
                if (input.checked) document.getElementById('bpic').src = input.dataset.imagesourceStandard;
            });
            document.getElementById('customtext').closest('.input-group').classList.remove('d-none');
        }
    };
    document.querySelectorAll('input[name="portraitonly"]').forEach((input)=>{
        input.addEventListener('change', updatePortraitOnly);
    });
    // Add event listeners to all radio buttons with name 'size'
    const sizeRadios = document.querySelectorAll('input[name="size"]');
    sizeRadios.forEach((radio)=>{
        radio.addEventListener('change', handleAccordionChange);
        radio.addEventListener('change', updateSizeOptions);
    });
    // Add event listeners to all radio buttons with name 'style'
    const styleRadios = document.querySelectorAll('input[name="style"]');
    styleRadios.forEach((radio)=>{
        radio.addEventListener('change', handleAccordionChange);
        radio.addEventListener('change', (element)=>{
            const input = document.querySelector('input[name="style"]:checked');
            if (!input) return;
            switch(input.value){
                case 'standard':
                    updateSizeOptions();
                    break;
            }
        });
    });
    // Add event listeners to all radio buttons with name 'style'
    const frameRadios = document.querySelectorAll('input[name="products[0]"]');
    frameRadios.forEach((radio)=>{
        radio.addEventListener('change', handleAccordionChange);
    });
    let pyoMinDate = new Date();
    pyoMinDate.setDate(new Date().getDate() + 1);
    let fedexMinDate = new Date();
    fedexMinDate.setDate(new Date().getDate() + 1);
    let shipMinDate = new Date();
    shipMinDate.setDate(new Date().getDate() + 2);
    const datepicker = flatpickr("#timeneededpicker", {
        allowInput: false,
        altInput: false,
        altFormat: "F j, Y h:i K",
        dateFormat: "F j, Y h:i K",
        enableTime: true,
        minDate: new Date().fp_incr(1),
        maxDate: new Date().fp_incr(365) // 365 days from now
    });
    function updateDeliveryInfo() {
        const timerContainer = document.getElementById("delivery-timer");
        const countdownElement = document.getElementById("countdown");
        const deliveryDateElement = document.getElementById("delivery-date");
        const deliveryDateRangeElement = document.getElementById("delivery-date-range");
        const pyoDeliveryDateElement = document.getElementById("pyo-delivery-date");
        // Use Intl to get local time in Austin, TX (Central Time)
        const now = new Date();
        // Helper: Format date as Central Time
        function getCentralTime(date) {
            return new Date(date.toLocaleString("en-US", {
                timeZone: "America/Chicago"
            }));
        }
        const cstTime = getCentralTime(now);
        const cutoffHour = 13; // 1 PM local time in Austin, TX
        // Helper: Check if a date is a weekend
        function isWeekend(date) {
            const day = date.getDay();
            return day === 0 || day === 6; // Sunday = 0, Saturday = 6
        }
        // Modified getNextBusinessDay that skips weekends and federal holidays
        function getNextBusinessDay(start) {
            let result = new Date(start);
            do result.setDate(result.getDate() + 1);
            while (isWeekend(result) || (0, (/*@__PURE__*/$parcel$interopDefault($6ec7bc9bec7fad01$exports))).isAHoliday(result));
            return result;
        }
        // Set target time to 1 PM local time in Austin
        let targetTime = getCentralTime(now);
        targetTime.setHours(cutoffHour, 0, 0, 0);
        const timeFormatter = new Intl.DateTimeFormat(undefined, {
            hour: 'numeric',
            minute: 'numeric'
        });
        if (cstTime > targetTime) {
            if (cstTime.getDay() === 5 || cstTime.getDay() === 6) {
                pyoMinDate = (0, $952ed55040a5dee1$export$7e1e8af4bb294f2b)(new Date(targetTime.getFullYear(), targetTime.getMonth(), targetTime.getDate() + (7 - cstTime.getDay()) % 7, 6, 0, 0, 0), 'America/Chicago');
                pyoDeliveryDateElement.innerText = "Sunday by ";
            } else if (isWeekend(cstTime)) {
                pyoMinDate = (0, $952ed55040a5dee1$export$7e1e8af4bb294f2b)(new Date(targetTime.getFullYear(), targetTime.getMonth(), targetTime.getDate() + 1, 11, 0, 0, 0), 'America/Chicago');
                pyoDeliveryDateElement.innerText = "tomorrow by ";
            } else {
                pyoMinDate = (0, $952ed55040a5dee1$export$7e1e8af4bb294f2b)(new Date(targetTime.getFullYear(), targetTime.getMonth(), targetTime.getDate() + 1, 11, 0, 0, 0), 'America/Chicago');
                pyoDeliveryDateElement.innerText = "tomorrow by ";
            }
            pyoDeliveryDateElement.innerText += timeFormatter.format(pyoMinDate);
        } else {
            pyoMinDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() + 5, now.getMinutes(), now.getSeconds(), 0);
            pyoDeliveryDateElement.innerText = "in five hours";
        }
        // If past cutoff or weekend, move to the next business day at 3 PM
        if (cstTime > targetTime || isWeekend(cstTime)) {
            targetTime = getNextBusinessDay(targetTime);
            targetTime.setHours(cutoffHour, 0, 0, 0);
        }
        // Calculate delivery date (2 business days from order day)
        const deliveryDate = getNextBusinessDay(getNextBusinessDay(getNextBusinessDay(new Date(targetTime))));
        const deliveryDateFormatter = new Intl.DateTimeFormat(navigator.language, {
            month: 'short',
            day: 'numeric'
        });
        const deliveryDateFormatterDayOnly = new Intl.DateTimeFormat(navigator.language, {
            day: 'numeric'
        });
        deliveryDateElement.textContent = deliveryDateFormatter.format(deliveryDate);
        shipMinDate = deliveryDate; // Rush shipping min date (used for countdown timer delivery date)
        // Read region-based transit days from data attributes (set server-side from user's state)
        // Falls back to 4-6 business days if attributes are missing or invalid
        const transitMin = parseInt(deliveryDateRangeElement.dataset.transitMin, 10) || 4;
        const transitMax = parseInt(deliveryDateRangeElement.dataset.transitMax, 10) || 6;
        // Add business days from targetTime for early and late delivery dates
        function addBusinessDays(start, days) {
            let result = new Date(start);
            let added = 0;
            while(added < days){
                result.setDate(result.getDate() + 1);
                if (!isWeekend(result) && !(0, (/*@__PURE__*/$parcel$interopDefault($6ec7bc9bec7fad01$exports))).isAHoliday(result)) added++;
            }
            return result;
        }
        const earlyDeliveryDate = addBusinessDays(new Date(targetTime), transitMin);
        const lateDeliveryDate = addBusinessDays(new Date(targetTime), transitMax);
        deliveryDateRangeElement.textContent = deliveryDateFormatter.format(earlyDeliveryDate) + ' - ' + deliveryDateFormatterDayOnly.format(lateDeliveryDate);
        // Always show timer
        timerContainer.classList.remove("d-none");
        function updateCountdown() {
            const now = new Date();
            const currentTimeCT = getCentralTime(now);
            const timeDifference = targetTime - currentTimeCT;
            if (timeDifference <= 0) {
                clearInterval(countdownInterval);
                // Automatically reset countdown to next cutoff
                setTimeout(()=>{
                    updateDeliveryInfo();
                }, 1000);
                return;
            }
            const totalSeconds = Math.floor(timeDifference / 1000);
            const totalMinutes = Math.floor(totalSeconds / 60);
            const totalHours = Math.floor(totalMinutes / 60);
            const days = Math.floor(totalHours / 24);
            const hours = totalHours % 24;
            const minutes = totalMinutes % 60;
            let displayText = "";
            // Helper to format time like "3:45 PM"
            function formatTime(date) {
                return date.toLocaleTimeString(navigator.language, {
                    hour: 'numeric',
                    minute: '2-digit'
                });
            }
            const formattedCutoff = formatTime(targetTime);
            if (days === 0) {
                if (hours === 0) displayText = `within ${minutes} minute${minutes !== 1 ? "s" : ""}`;
                else displayText = `within ${hours} hour${hours !== 1 ? "s" : ""} and ${minutes} minute${minutes !== 1 ? "s" : ""}`;
            } else if (days === 1) displayText = `by tomorrow before ${formattedCutoff}`;
            else if (days < 3) {
                const dayOfWeek = targetTime.toLocaleDateString("en-US", {
                    weekday: "long"
                });
                displayText = `by ${dayOfWeek} before ${formattedCutoff}`;
            } else {
                const dayOfWeek = targetTime.toLocaleDateString("en-US", {
                    weekday: "long"
                });
                displayText = `by next ${dayOfWeek} before ${formattedCutoff}`;
            }
            countdownElement.textContent = displayText;
        }
        updateCountdown(); // Initial call
        const countdownInterval = setInterval(updateCountdown, 1000);
    }
    updateDeliveryInfo();
    const updateDeliveryOptions = ()=>{
        const selected = document.querySelector('input[name="delivery"]:checked');
        if (!selected) return;
        switch(selected.value){
            case 'pyo':
                datepicker.set('minDate', pyoMinDate);
                break;
            case 'pdp':
            case 'pd':
                datepicker.set('minDate', fedexMinDate);
                break;
            default:
                datepicker.set('minDate', shipMinDate);
        }
        if ('pyo' === selected.value || 'pdp' === selected.value || 'pd' === selected.value) {
            document.querySelectorAll('#choose-size-item-fedex-pickup,#choose-size-item-fedex-delivery,#choose-style-item-fedex,#choose-size-item,.choose-frame-item,#choose-size-item-pyo').forEach(itemVisibilityHide);
            if ('pdp' === selected.value) document.querySelectorAll('#choose-size-item-fedex-pickup,#choose-style-item-fedex').forEach(itemVisibilityShow);
            else if ('pd' === selected.value) document.querySelectorAll('#choose-size-item-fedex-delivery,#choose-style-item-fedex').forEach(itemVisibilityShow);
            else document.querySelectorAll('#choose-size-item-pyo').forEach(itemVisibilityShow);
        } else {
            document.querySelectorAll('#choose-size-item,#choose-style-item').forEach((item)=>{
                item.classList.remove('d-none');
                item.querySelectorAll('input[data-required]').forEach((input)=>{
                    input.setAttribute('required', true);
                });
            });
            updateSizeOptions();
            document.querySelectorAll('#choose-size-item-fedex-pickup,#choose-size-item-fedex-delivery,#choose-style-item-fedex,#choose-size-item-pyo').forEach(itemVisibilityHide);
        }
    };
    document.querySelectorAll('input[name="delivery"]').forEach((radio)=>{
        radio.addEventListener('change', updateDeliveryOptions);
    });
    updateDeliveryOptions();
    // Initialize with the first checked radio button, if any
    const checkedRadios = document.querySelectorAll('input[type="radio"].btn-check:checked');
    checkedRadios.forEach((radio)=>{
        const headerTextElement = radio.closest('.accordion-item').querySelector('.accordion-button .js-chosen');
        headerTextElement.innerText = radio.getAttribute('data-name');
    });
    document.querySelectorAll('#companylogo').forEach((checkbox)=>{
        const logoCollapse = new bootstrap.Collapse('#logoform', {
            toggle: false
        });
        checkbox.addEventListener('change', (element)=>{
            if (checkbox.checked) logoCollapse.show();
            else logoCollapse.hide();
        });
    });
    // Initialize the total price
    updateTotalPrice();
    // Flatpickr initialization
    // Add event listener to the "Show All Backgrounds" button
    const showAllBackgroundsButton = document.querySelector('#showallbackgrounds');
    if (showAllBackgroundsButton) {
        showAllBackgroundsButton.addEventListener('click', function(e) {
            e.preventDefault();
            const parentElement = this.parentElement.nextElementSibling;
            // Check if the parent element has the 'expanded' class
            if (parentElement.classList.contains('expanded')) {
                // If it does, remove the 'expanded' class and set max-height back to 262px
                parentElement.classList.remove('expanded');
                parentElement.style.maxHeight = '362px';
                this.innerText = 'Show All Backgrounds';
                document.querySelector('#accordionOptions').scrollIntoView();
            } else {
                // If it doesn't, add the 'expanded' class and set max-height to none
                parentElement.classList.add('expanded');
                parentElement.style.maxHeight = '6500px';
                this.innerText = 'Hide Additional Backgrounds';
            }
        });
        // Auto-expand backgrounds if URL fragment is #showallbackgrounds
        if (window.location.hash === '#showallbackgrounds') showAllBackgroundsButton.click();
    }
    'use strict';
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.needs-validation');
    // Loop over them and prevent submission
    Array.from(forms).forEach((form)=>{
        form.addEventListener('submit', (event)=>{
            if (datepicker.selectedDates.length <= 0) {
                datepicker.open();
                event.preventDefault();
                event.stopPropagation();
                datepicker.input.classList.remove('is-valid');
                datepicker.input.classList.add('is-invalid');
            } else {
                datepicker.close();
                datepicker.input.classList.remove('is-invalid');
                datepicker.input.classList.add('is-valid');
            }
            if (!form.checkValidity()) {
                if (event.submitter.id === 'resetBtn') // We're only resetting.
                return;
                event.preventDefault();
                event.stopPropagation();
            }
            form.classList.add('was-validated');
            // Find the first invalid element
            const invalidElements = form.querySelectorAll('.was-validated :invalid ~ .invalid-feedback,.btn-check:invalid, .form-control:invalid, .is-invalid');
            let firstInvalidElement = null;
            for(let i = 0; i < invalidElements.length; i++)if (invalidElements[i].offsetParent !== null) {
                firstInvalidElement = invalidElements[i];
                break;
            }
            // If an invalid element is found, scroll to it
            if (firstInvalidElement) {
                window.scrollTo({
                    top: firstInvalidElement.getBoundingClientRect().top + window.scrollY - 100,
                    behavior: 'smooth'
                });
                // Focus the invalid element for better UX
                firstInvalidElement.focus();
            }
        }, false);
    });
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [
        ...tooltipTriggerList
    ].map((tooltipTriggerEl)=>new bootstrap.Tooltip(tooltipTriggerEl));
    //, {trigger:'click'}
    document.getElementById('togglezoom').addEventListener('click', (event)=>{
        event.stopPropagation();
        event.preventDefault();
        document.querySelectorAll('[data-style-zoom]').forEach((elem)=>{
            elem.dataset.styleOrig = elem.style.cssText;
            elem.style = elem.dataset.styleZoom;
        });
        const resetStyles = ()=>{
            document.querySelectorAll('[data-style-zoom]').forEach((elem)=>{
                elem.style = elem.dataset.styleOrig;
            });
        };
        const escHandler = (event)=>{
            if (event.key === 'Escape') {
                resetStyles();
                document.removeEventListener('click', clickHandler);
                document.removeEventListener('keydown', escHandler);
            }
        };
        const clickHandler = ()=>{
            event.stopPropagation();
            event.preventDefault();
            resetStyles();
            document.removeEventListener('keydown', escHandler);
            document.removeEventListener('click', clickHandler);
        };
        document.addEventListener('click', clickHandler);
        document.addEventListener('keydown', escHandler);
    });
    document.querySelectorAll('#choose-frame-item input[name="products[0]"]').forEach((input)=>{
        input.addEventListener('change', (event)=>{
            const input = document.querySelector('input[name="products[0]"]:checked');
            if (!input) return;
            document.getElementById('framed').checked = true;
        });
    });
    document.querySelectorAll('#choose-frame-item input[name="style"]').forEach((input)=>{
        input.addEventListener('change', (event)=>{
            const input = document.querySelector('input[name="style"]:checked');
            if (!input) return;
            if (input.id !== 'framed') document.querySelectorAll('#choose-frame-item input[name="products[0]"]').forEach((input)=>{
                input.required = false;
                input.checked = false;
            });
            else document.querySelectorAll('#choose-frame-item input[name="products[0]"]').forEach((input)=>{
                input.required = true;
            });
        });
    });
});

})();
//# sourceMappingURL=order.js.map
